<template>

  <div class="mOperation-wrap">
    <!----------- operation ---------->
    <div class="mOperation">
      <ul class="clearfix">
        <li class="pull-left" style="max-width: calc(100% - 100px);">
          <template v-if="gridConfig.canCheckedAll">
            <span class="mOperation-data" v-show="!selectAllRows && checkedRows.length > 0">
              已选择 <span>{{ checkedRows.length }}</span>/{{ totalCount }}条数据，<a @click="handleSelectAllRow" href="javascript:" class="btn-link">选择全部数据</a>
            </span>
            <span class="mOperation-data" v-show="selectAllRows && checkedRows.length > 0">
              已选择全部 <span>{{ totalCount }}</span> 条筛选结果
            </span>
          </template>
          <template v-else>
            <span class="mOperation-data" v-show="!selectAllRows && checkedRows.length > 0">
              已选择 <span>{{ checkedRows.length }}</span>/{{ totalCount }} 条数据
            </span>
          </template>
          <!--非必选记录菜单-->
          <span v-show="checkedRows.length === 0">
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow btn-icon"
               v-show="gridConfig.canAdd"
               @click="handleAddButton()" style="margin-right: 3px;"
            ><i class="mng icon-add-stroke"></i>添加</a>
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow btn-icon"
               v-show="gridConfig.canBatchAdd" style="margin-right: 3px;"
               @click="handleImport()"
            ><i class="mng icon-batchimport-stroke"></i>Excel导入</a>
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow btn-icon"
               v-for="menu in gridConfig.gridMenuList"
               v-if="menu.showType === 'top' && !menu.mustSelectRow && menu.type !== 'magicalMenu'"
               @click="handleMenuClick(menu)"
               style="margin-right: 3px;"
            >{{ menu.text }}</a>
            <slot name="topNoSelectMenus"></slot>
          </span>
          <!--必选记录菜单-->
          <a
            href="javascript:" ondragstart="return false"
            :class="'btn ' + (checkedRows.length > 0 ? 'btn-hollow' : 'btn-hind') + ' btn-icon'"
            style="margin-right: 3px;"
            v-show="gridConfig.canDelete"
            @click="checkedRows.length > 0 && handleDelete()"
          ><i class="mng icon-delete-stroke"></i>删除</a>
          <a href="javascript:" ondragstart="return false"
             :class="'btn '+(checkedRows.length > 0? 'btn-hollow':'btn-hind')"
             v-for="menu in gridConfig.gridMenuList"
             v-if="menu.showType === 'top' && menu.mustSelectRow && menu.type !== 'magicalMenu'"
             @click="checkedRows.length > 0 && handleMenuClick(menu)"
             style="margin-right: 3px;"
          >{{ menu.text }}</a>
          <!--自定义必选菜单：未勾选置灰，勾选后可用-->
          <span :class="checkedRows.length > 0 ? '' : 'topSelectMenusHind'">
            <span :class="checkedRows.length > 0 ? '' : 'mask'"></span>
            <slot name="topSelectMenus"></slot>
          </span>
        </li>
        <li class="pull-right">
          <a href="javascript:" v-show="checkedRows.length > 0"
             ondragstart="return false"
             class="btn-shut mOperation-shut"
             @click="handleClearCheckRow"
          >
            <i class="mng icon-cross-stroke"></i>
            <span>取消</span>
          </a>
          <div v-show="checkedRows.length === 0">
            <div class="pull-right-item">
              <el-dropdown trigger="click" :show-timeout="10" >
                <el-tooltip class="item" effect="dark" content="选择字段" placement="top">
                  <a href="javascript:" class="btn btn-icon btn-icon-only"><i class="mng icon-field-stroke"></i></a>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown" >
                  <div class="drop-operation select-column-drop">
                    <div class="drop-top">
                      <div class="drop-field">
                        <span class="pull-left drop-txt">选择显示字段</span>
                        <label class="pull-right form-label drop-checkbox">
                          <span class="checkbox-btn"></span>
                          <input type="checkbox" v-model="showAllColumn" @click="handleShowAllColumnCheckbox">
                          全选
                        </label>
                      </div>
                    </div>
                    <div class="drop-mid">
                      <el-scrollbar class="whaty-scroll">
                        <ul class="drop-list-wrap" id="fieldlist">
                          <li v-for="item in gridConfig.listColumnConfig"
                              v-if="item.list"
                              @click="toggleColumnShow(item)"
                              class="drop-list">
                            <a href="javascript:" class="drop-link" :class="{'drop-select': (item.show === undefined || item.show)}">
                              <span class="drop-txt">{{ item.name }}</span>
                              <i class="mng icon-tick-stroke drop-ico-suf drop-ico-tick"></i>
                            </a>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="pull-right-item">
              <el-dropdown trigger="click" :show-timeout="10" >
                <el-tooltip class="item" effect="dark" content="冻结列" placement="top">
                  <a href="javascript:" class="btn btn-icon btn-icon-only"><i class="mng icon-freeze-stroke"></i></a>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown" >
                  <div class="drop-operation select-column-drop">
                    <div class="drop-top">
                      <div class="drop-field">
                        <span class="pull-left drop-txt">选择冻结字段</span>
                      </div>
                    </div>
                    <div class="drop-mid">
                      <el-scrollbar class="whaty-scroll">
                        <ul class="drop-list-wrap" id="fixFieldlist">
                          <li v-for="item in gridConfig.listColumnConfig"
                              v-if="item.list"
                              @click="toggleColumnFix(item)"
                              class="drop-list">
                            <a href="javascript:" class="drop-link" :class="{'drop-select': (item.fix === 'left')}">
                              <span class="drop-txt">{{ item.name }}</span>
                              <i class="mng icon-tick-stroke drop-ico-suf drop-ico-tick"></i>
                            </a>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="pull-right-item">
              <el-tooltip class="item" effect="dark" :content="showSearchForm ? '收起筛选' : '展开筛选'" placement="top">
                <a @click="handleToggleSearchForm"
                   href="javascript:" class="btn btn-icon btn-icon-only">
                  <i :class="[showSearchForm ? 'icon-arrUp-round' : 'icon-arrDn-round']" class="mng"></i></a>
              </el-tooltip>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import WhatyDialog from '../dialog/dialog.vue'

  export default {
    name: 'grid-top-operation',
    components: {
      WhatyDialog
    },
    props: {
      gridConfig: {},
      checkedRows: {
        type: Array,
        default() {
          return []
        }
      },
      showSearchForm: {
        type: Boolean,
        required: true
      },
      pageSize: {
        type: Number,
        default: 0
      },
      curPage: {
        type: Number,
        default: 0
      },
      totalCount: {
        type: Number,
        default: 0
      },
      selectAllRows: {
        type: Boolean
      },
      updateColumnUrl: {
        type: String,
        required: true
      },
      menus: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        addButtonStatus: false, // 添加按钮开关
        showSelectColumnPanel: false, // 显示选择列面板
        showFreezeColumnPanel: false, // 显示选择冻结列面板
        freezeColumn: 0 // 冻结的列
      }
    },
    computed: {
      showAllColumn: { // 显示全部列
        get: function () {
          if (this.gridConfig.listColumnConfig) {
            for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
              if (this.gridConfig.listColumnConfig[i].list && this.gridConfig.listColumnConfig[i].show === false) {
                return false
              }
            }
          }
          return true
        },
        set: function (newValue) {}
      },
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    created: function () {
    },
    methods: {
      handleClearCheckRow() {
        this.$emit('clear-check-row')
      },
      handleSelectAllRow() {
        this.$emit('select-all-row')
      },
      handleAddButton() { // 点击添加按钮
        this.$emit('add-button-click')
      },
      handleImport() { // 点击导入按钮
        this.$emit('import')
      },
      handleToggleSearchForm() {
        this.$emit('toggle-search-form')
      },
      handleDelete() { // 删除
        this.$emit('delete-button-click')
      },
      toggleColumnShow(column) { // 切换列显示隐藏
        this.$emit('toggle-column-show', column)
      },
      toggleColumnFix(column) { // 切换列冻结状态
        this.$emit('toggle-column-fix', column)
      },
      handleShowAllColumnCheckbox(e) { // 全选 / 取消全选
        if (e.target.checked) {
          this.$emit('show-all-column')
        } else {
          this.$emit('hide-all-column')
        }
      },
      handleMenuClick(menu) {
        this.$emit('menu-click', menu)
      },
      handleGridMenuClick(gridMenu) {
        if (gridMenu.menuClick && typeof gridMenu.menuClick === 'function') {
          gridMenu.menuClick.call(this, gridMenu)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-top-operation.vue